export const MUTATION_GROUP = 'richTextFields' as const;
